<template>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    :custom-filter="multiFilter"
    class="elevation-1"
    density="compact"
    height="500"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.Proceso="{ item }">
      <div>
        {{ item.raw.Proceso + "-" + item.raw.DescProceso }}
      </div>
    </template>
    <template v-slot:item.Proceso_Origen_Anterior="{ item }">
      <div>
        {{
          item.raw.Proceso_Origen_Anterior +
          "-" +
          item.raw.DescProceso_Origen_Anterior
        }}
      </div>
    </template>
    <template v-slot:item.Fecha_Inicio="{ item }">
      <div>
        {{ item.raw.Fecha_Inicio + " " + item.raw.Hora_Inicio }}
      </div>
    </template>
    <template v-slot:item.Fecha_Fin="{ item }">
      <div>
        {{ item.raw.Fecha_Fin + " " + item.raw.Hora_Fin }}
      </div>
    </template>
    <template v-slot:item.TemporizadorEnd="{ item }">
      <v-chip :color="getColor(item)" dark>
        <v-tooltip location="bottom" color="white">
          <template v-slot:activator="{ props }">
            <span v-bind="props"
              >{{
                item.raw.Dias_Reales < 10
                  ? "0" + item.raw.Dias_Reales
                  : item.raw.Dias_Reales
              }}-{{
                item.raw.Horas_RealesFin < 10
                  ? "0" + item.raw.Horas_RealesFin
                  : item.raw.Horas_RealesFin
              }}:{{
                item.raw.Minutos_Reales < 10
                  ? "0" + item.raw.Minutos_Reales
                  : item.raw.Minutos_Reales
              }}:{{
                item.raw.Segundos_Reales < 10
                  ? "0" + item.raw.Segundos_Reales
                  : item.raw.Segundos_Reales
              }}</span
            >
          </template>
          <span>DD-hh:mm:ss</span>
        </v-tooltip>
      </v-chip>
    </template>
    <template v-slot:item.Temporizador="{ item }">
      <v-tooltip location="bottom" color="primary">
        <template v-slot:activator="{ props }">
          <span v-bind="props"
            >{{
              item.raw.Horas_Esperadas < 10
                ? "0" + item.raw.Horas_Esperadas
                : item.raw.Horas_Esperadas
            }}:{{
              item.raw.Minutos_Esperados < 10
                ? "0" + item.raw.Minutos_Esperados
                : item.raw.Minutos_Esperados
            }}:00</span
          >
        </template>
        <span>hh:mm:ss</span>
      </v-tooltip>
    </template>
  </v-data-table>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import store from "@/store";
export default {
  props: {
    NumeroSolicitud: {
      type: Number,
      default: 0,
      Description: "Numero de Solicitud",
    },
  },
  data() {
    return {
      search: "",
      progreso: false,
      headers: [
        {
          title: "Proceso",
          align: "start",
          key: "Proceso",
        },
        {
          title: "Proceso Anterior",
          align: "start",
          key: "Proceso_Origen_Anterior",
        },
        {
          title: "Usuario Originó",
          align: "start",
          key: "DescUsuario_Origino",
        },
        {
          title: "Usuario Terminó",
          align: "start",
          key: "DescUsuario_Termino",
        },
        {
          title: "Fecha Inicial",
          align: "start",
          key: "Fecha_Inicio",
        },
        {
          title: "Fecha Final",
          align: "start",
          key: "Fecha_Fin",
        },
        {
          title: "Tiempo Esperado",
          align: "center",
          key: "Temporizador",
        },
        {
          title: "Tiempo Final",
          align: "center",
          key: "TemporizadorEnd",
        },
      ],
      desserts: [],
    };
  },
  methods: {
    multiFilter(value, search, item) {
      console.log(search);
      console.log(item);
      console.log(value);
      if (!search) return true;

      search = search.toLowerCase();

      return (
        String(item.raw.DescProceso ?? "")
          .toLowerCase()
          .includes(search) ||
        String(item.raw.DescProceso_Origen_Anterior ?? "")
          .toLowerCase()
          .includes(search) ||
        String(item.raw.DescUsuario_Origino ?? "")
          .toLowerCase()
          .includes(search) ||
        String(item.raw.DescUsuario_Termino ?? "")
          .toLowerCase()
          .includes(search)
      );
    },
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    // Consulta Solicitudes
    async getHistoricoProcesos() {
      this.desserts = [];
      this.progreso = true;
      this.axios
        .get(
          "/Procesos/NroSolicitudLineaProceso/getAllSolicitudProcesos/" +
            this.NumeroSolicitud,
        )
        .then((result) => {
          this.desserts = result.data;
        })
        .catch((error) => {
          const registro = error.response.data;
          const mensajeerror =
            registro.Mensaje || registro.ExceptionMessage || registro;
          switch (error.response.status) {
            case 404:
              this.$swal({
                icon: "warning",
                title: "Consulta inexistente.",
                html: " [404] No existen datos para esta consulta.",
              });
              break;
            default:
              this.$swal({
                icon: "error",
                title: "Error al consultar",
                html:
                  " [500] El servidor ha encontrado la siguiente condicion inesperada: <br><small><code>" +
                  mensajeerror +
                  "</code></small>",
              });
              break;
          }
        })
        .finally(() => {
          this.progreso = false;
        });
    },
    ///////////////////////////////////////////////// Métodos de acciones //////////////////////////////////////////
    //Cambio de color de acuerdo a la fechas existentes
    getColor(itemtime) {
      if (itemtime.Segundos_Esperados < itemtime.Segundos_Totales) {
        return "red";
      } else {
        return "green";
      }
    },
  },
  mounted() {
    this.getHistoricoProcesos();
  },
};
</script>
